import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ModalService, SimpleMessageService, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Subscription } from 'rxjs';
import { ReleaseDto } from 'src/app/models/release/release-dto';
import { ForgeService } from 'src/app/services/forge.service';
import { ReleaseRowComponent } from '../release-row/release-row.component';

@Component({
    selector: 'oaibox-delete-release-warning-modal',
    templateUrl: './delete-release-warning-modal.component.html',
    styleUrls: ['./delete-release-warning-modal.component.css'],
    imports: [WebAppCommonModule, forwardRef(() => ReleaseRowComponent)],
})
export class DeleteReleaseWarningModalComponent implements OnDestroy {

  @Input({ required: true }) public release!: ReleaseDto;

  private deleteReleaseSubscription?: Subscription;

  constructor(
    private readonly forgeService: ForgeService,
    private readonly simpleMessageService: SimpleMessageService,
    private readonly modalService: ModalService) {
  }

  protected deleteClient(): void {
    const releaseId = this.release.id;
    if (releaseId)
      this.deleteReleaseSubscription = this.forgeService.deleteRelease(releaseId)
        .subscribe({
          next: () => {
            this.forgeService.refreshReleases();
            this.simpleMessageService.showSimpleMessage({
              message: 'Release deleted successfully!',
              icon: 'fa-solid fa-check-double',
              color: 'success',
            });
            this.modalService.popModal();
          },
          error: () => {
            this.simpleMessageService.showSimpleMessage({
              message: 'Release not deleted!',
              icon: 'fa-solid fa-triangle-exclamation',
              color: 'danger',
            });
            this.modalService.popModal();
          },
        });
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.deleteReleaseSubscription?.unsubscribe();
  }
}
